module.exports = __webpack_public_path__ + "static/img/BF.95153b27.png";